<template>
  <PopUpContents
    ref="popup"
    height="42rem"
  >
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="item-fluid p-3 m-2 h-100 d-flex flex-column">
      <!-- ----------------- -->
      <!-- row 1 - title     -->
      <!-- ----------------- -->
      <div class="row h-40">
        <p class="bb-page-title mt-3 mb-2">{{ title }}</p>
      </div>
      <!-- -------------- -->
      <!--  row 3 - note  -->
      <!-- -------------- -->
      <div class="row mt-3 mb-3 flex-grow-1">
        <div class="row mt-2 mb-2 align-items-start">
          <div class="col-4 form-group">
            <div class="form-floating">
              <input
                id="session-date"
                name="session-date"
                type="date"
                class="form-control"
                v-model="session_date"
                required
              />
              <label
                class="bb-float-label"
                for="session-date"
                >Session Date</label
              >
            </div>
          </div>
          <div class="col-8 d-flex justify-content-end align-self-start pt-1">
            <div
              class="btn-group special flex-row-reverse"
              role="group"
            >
              <!-- ------------ -->
              <!--    cancel    -->
              <!-- ------------ -->
              <button
                v-if="cancelButton"
                type="button"
                @click="_cancel"
                class="btn btn-lg btn-warning"
              >
                {{ cancelButton }}
              </button>
              <!-- ------------ -->
              <!--    add/ok    -->
              <!-- ------------ -->
              <button
                v-if="okButton"
                type="button"
                :disabled="isEmpty || isSessionDateEmpty || !isChanged"
                @click="_confirm"
                class="btn btn-lg btn-primary"
              >
                {{ okButton }}
              </button>
            </div>
          </div>
        </div>
        <!-- ------- -->
        <!--  note   -->
        <!-- ------- -->
        <div class="row mt-2 mb-2 flex-grow-1">
          <div class="col form-group d-flex flex-column">
            <div class="form-floating flex-grow-1">
              <textarea
                id="note"
                name="note"
                type="text"
                rows="8"
                placeholder="..."
                class="form-control bb-textarea-with-label bb-textarea-with-label-compact bb-card-description-control bb-campaign-note-control"
                style="height: 100%"
                v-model="note"
                autocomplete="off"
                :maxlength="maxLength"
              ></textarea>
              <label
                class="bb-float-label"
                for="note"
                >Note</label
              >
            </div>
          </div>
        </div>
        <!-- ------------------ -->
        <!--  character count   -->
        <!-- ------------------ -->
        <div
          class="row mt-2 d-flex justify-content-end bb-letter-count-control"
        >
          [ {{ note?.length ?? 0 }} of {{ maxLength }} ]
        </div>
      </div>
    </div>
  </PopUpContents>
</template>

<script>
import PopUpContents from './PopUpContents.vue'
import getTodayISODate from '../helpers/getTodayISODate'

export default {
  name: 'CampaignNoteDialog',
  components: {
    PopUpContents,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    title: undefined,
    subject: undefined,
    message: undefined,
    okButton: undefined,
    cancelButton: undefined,
    rejectPromise: undefined,
    resolvePromise: undefined,
    note: null,
    session_date: '',
    maxLength: 2000,
    original_note: null,
    original_session_date: '',
  }),
  //=====================================================================
  // computed
  //----------
  computed: {
    isEmpty() {
      return String(this.note || '').trim().length === 0
    },
    isSessionDateEmpty() {
      return String(this.session_date || '').trim().length === 0
    },
    isChanged() {
      return (
        this.note !== this.original_note ||
        this.session_date !== this.original_session_date
      )
    },
  },
  //=====================================================================
  // methods
  //---------
  methods: {
    //================================================================================
    // show dialog
    //-------------
    show(opts = {}) {
      // passed parms
      this.title = opts.title
      this.subject = opts.subject
      this.message = opts.message
      this.note = opts.note
      this.session_date = opts.session_date || getTodayISODate()

      this.original_note = this.note
      this.original_session_date = this.session_date

      if (opts.okButton) {
        this.okButton = opts.okButton
      }
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }

      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //================================================================================
    // cancel
    //--------
    _cancel() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({ cancel: true })
      }
    },
    //================================================================================
    // confirm
    //---------
    _confirm() {
      const popup = this.$refs.popup
      if (popup && typeof popup.close === 'function') {
        popup.close()
      }
      if (this.resolvePromise) {
        this.resolvePromise({
          cancel: false,
          ok: true,
          note: this.note,
          session_date: this.session_date,
        })
      }
    },
  },
}
</script>
